import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'public-parking';

export function useGetAllPublicParking(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetPublicParking(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreatePublicParking() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdatePublicParking({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeletePublicParking({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
